module.exports = __webpack_public_path__ + "img/logo.1831b1ae.png";